import {MEDIA_TYPES} from 'constants/dance.js'
import useUserInfo from 'logic/Auth/useUserInfo.js'
import {useState} from 'react'
import {useParams} from 'react-router-dom'
import {
    useGetDanceWithRelevantMediaQuery,
    useI18n,
    useIsRtl,
    useUpdateMainMediaMutation,
} from 'store/Store'

const useDance = () => {
    const isRtl = useIsRtl()
    const {i18n} = useI18n()
    const [open, setOpen] = useState(false)
    const {danceId} = useParams()
    const [activeTab, setActiveTab] = useState(MEDIA_TYPES.video)
    const [doUpdateMainMedia] = useUpdateMainMediaMutation()
    const {isLoggedIn} = useUserInfo()
    const {data: dance, isLoading} = useGetDanceWithRelevantMediaQuery({
        danceId,
        filter: activeTab,
    })

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue)
    }

    const handleIsMainClick = async (mediaId) => {
        await doUpdateMainMedia({danceId, mediaId})
    }
    const t = (label) => i18n.t(`dance.${label}`)

    const handleOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
    }

    return {
        isRtl,
        open,
        isLoggedIn,
        isLoading,
        handleOpen,
        handleClose,
        activeTab,
        handleTabChange,
        handleIsMainClick,
        dance,
        addMediaText: t('addMedia'),
        addMediaForLoggedUsersText: t('addMediaForLoggedUsers'),
        choreographersText: t('choreographers'),
        audioText: t('audio'),
        videoText: t('videos'),
        lyricistsText: t('lyricists'),
        composersText: t('composers'),
        waitingForApprovalText: t('WaitingForChoreographerApproval'),
    }
}

export default useDance
